import { SvgIcon } from '@material-ui/core';

const ArrowDownIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 19 12">
    <path
      d="M2.7325 0.600586L10 7.85225L17.2675 0.600586L19.5 2.83309L10 12.3331L0.5 2.83309L2.7325 0.600586Z"
      fill="#514F4F"
    />
  </SvgIcon>
);

export default ArrowDownIcon;
